import PropTypes from 'prop-types';
import React from 'react';
import IllustrationContainer from '../../../common/illustration/IllustrationContainer';
import AudioContainer from '../../../common/audio/audioContainer';
import ReadingTip from '../../../common/components/ReadingTip';
import GoButtonDark from '../../../common/components/GoButtonDark';
import LoadingPage from '../../../common/components/LoadingPage';
import MiniCardLayout from '../../../common/layouts/miniCardLayout';
import { SPINNER } from '../../../constants/components';
import { ARIA_LABELS } from '../../../constants/text';
import { setArPageTitle } from '../../troUtils';

export default class TRCStartView extends React.Component {
    constructor(props) {
        super(props);
        setArPageTitle(props.isExternalURLSourcePresent, 'Book Introduction');
        this.getPageContent = this.getPageContent.bind(this);
    }

    componentDidMount() {
        const {
            showSpinner,
            fetchContent,
            trackStartPreAssessmentStep,
            isExternalURLSourcePresent,
        } = this.props;

        showSpinner();
        fetchContent();
        if (!isExternalURLSourcePresent) trackStartPreAssessmentStep();
    }

    componentDidUpdate(prevProps) {
        const {
            hideSpinner,
            isDataFetched,
            narrateScreen,
            bookIntroAudio,
            caption,
            isExternalURLSourcePresent,
            playlistItemInProgress,
            arLanguage,
        } = this.props;

        if (isDataFetched && !prevProps.isDataFetched) {
            hideSpinner();
            narrateScreen(bookIntroAudio, caption, isExternalURLSourcePresent, playlistItemInProgress, arLanguage);
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    getPageContent() {
        const {
            bookTitle,
            bookCover,
            bookCoverAltText,
            bookLevel,
            isScreenBlocked,
            onNext,
            isExternalURLSourcePresent,
            bookIndex,
            trackNextPreAssesmentStep,
            trackCompletedPreAssessment,
        } = this.props;

        const caption = isExternalURLSourcePresent ? `Book ${bookIndex + 1} of 2` : '';

        const handleClickGoButton = () => {
            if (!isExternalURLSourcePresent) {
                trackNextPreAssesmentStep();
                trackCompletedPreAssessment();
            }
            onNext(isExternalURLSourcePresent);
        };

        return (
            <div className="book-start">
                <ReadingTip />
                {bookCover === undefined
                    ? <h1>{bookTitle}</h1>
                    : (
                        <IllustrationContainer
                            url={bookCover}
                            class="stimulus-illustration"
                            imageClass="book-cover"
                            caption={caption}
                            altText={bookCoverAltText} />
                    )}
                <p className="book-level hidden">{bookLevel}</p>
                <GoButtonDark
                    ariaLabel={ARIA_LABELS.START_BOOK}
                    text="Start"
                    onClick={handleClickGoButton}
                    isPulsating={!isScreenBlocked}
                    isEnabled={!isScreenBlocked} />
            </div>
        );
    }

    render() {
        const {
            isDataFetched,
            isScreenBlocked,
            isSpinnerVisible,
        } = this.props;

        return (
            <div>
                <MiniCardLayout
                    className="trc-start"
                    isScreenBlocked={isScreenBlocked}>
                    <div className="book-container">
                        {isDataFetched && this.getPageContent()}
                    </div>
                    <AudioContainer />
                </MiniCardLayout>
                {isSpinnerVisible && <LoadingPage spinnerConfig={SPINNER.DARK} />}
            </div>
        );
    }
}

TRCStartView.propTypes = {
    bookCover: PropTypes.string,
    bookCoverAltText: PropTypes.string,
    bookTitle: PropTypes.string,
    bookLevel: PropTypes.string,
    bookIntroAudio: PropTypes.string,
    caption: PropTypes.string,
    isDataFetched: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isSpinnerVisible: PropTypes.bool,
    onNext: PropTypes.func,
    fetchContent: PropTypes.func,
    cleanup: PropTypes.func,
    narrateScreen: PropTypes.func,
    showSpinner: PropTypes.func,
    hideSpinner: PropTypes.func,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
    arLanguage: PropTypes.string.isRequired,
    playlistItemInProgress: PropTypes.object,
    bookIndex: PropTypes.number.isRequired,
    trackStartPreAssessmentStep: PropTypes.func.isRequired,
    trackNextPreAssesmentStep: PropTypes.func.isRequired,
    trackCompletedPreAssessment: PropTypes.func.isRequired,
};

TRCStartView.defaultProps = {
    fetchContent: () => {},
    onNext: () => {},
    narrateScreen: () => {},
    showSpinner: () => {},
    hideSpinner: () => {},
    bookCover: undefined,
    bookCoverAltText: undefined,
    bookTitle: undefined,
    bookLevel: undefined,
    bookIntroAudio: undefined,
    caption: '',
    isDataFetched: false,
    isScreenBlocked: false,
    isSpinnerVisible: false,
    cleanup: () => {},
    playlistItemInProgress: undefined,
};
